import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import { useDomDirection } from '@design-system/hooks';
import { ContentDirection } from '@design-system/types';
import classNames from 'classnames';
import { forwardRef, useState, useRef, useCallback } from 'react';
import DatePicker from 'react-datepicker';
var DateField = forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$isHidden = _ref.isHidden,
    isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
    isDisabled = _ref.isDisabled,
    description = _ref.description,
    tooltipLabel = _ref.tooltipLabel,
    tooltipText = _ref.tooltipText,
    tooltipContent = _ref.tooltipContent,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    errorMessage = _ref.errorMessage,
    additionalHeadContent = _ref.additionalHeadContent,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    name = _ref.name,
    hideDays = _ref.hideDays,
    useLastDayOfMonth = _ref.useLastDayOfMonth;
  var _useState = useState(defaultValue ? new Date(defaultValue) : null),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = useState(defaultValue ? new Date(defaultValue) : null),
    _useState4 = _slicedToArray(_useState3, 2),
    utcDate = _useState4[0],
    setUtcDate = _useState4[1];
  var datePickerRef = useRef(null);
  var domDirection = useDomDirection();
  var toUTC = function toUTC(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
  };
  var handleOnChange = useCallback(function (date) {
    if (!date) return;
    var newDate = hideDays ? toUTC(new Date(date.getFullYear(), date.getMonth(), useLastDayOfMonth ? 0 : 1)) : toUTC(date);
    setStartDate(date);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      target: {
        value: newDate,
        name: name
      }
    });
    setUtcDate(newDate);
  }, [name, onChange, hideDays, useLastDayOfMonth]);
  var handleOnCalendarClose = useCallback(function () {
    if (onBlur) {
      onBlur({
        target: {
          value: utcDate,
          name: name
        }
      });
    }
  }, [utcDate, onBlur, name]);
  return jsxs("div", Object.assign({
    className: classNames('cds-date-field', className, {
      'cds-date-field--hidden': isHidden
    }),
    ref: ref
  }, {
    children: [jsx(FieldHead, {
      id: id,
      label: label,
      description: description,
      tooltipLabel: tooltipLabel,
      tooltipText: tooltipText,
      tooltipContent: tooltipContent,
      error: Boolean(errorMessage),
      additionalHeadContent: additionalHeadContent
    }), jsx("div", Object.assign({
      className: classNames('cds-date-field__container', {
        'cds-date-field__container--hide-days': hideDays
      })
    }, {
      children: jsx(DatePicker, Object.assign({
        className: classNames('cds-date-field__input', {
          'cds-date-field__input--error': Boolean(errorMessage),
          'cds-date-field__input--disabled': isDisabled
        }),
        selected: startDate,
        placeholderText: hideDays ? 'MM/YYYY' : 'DD/MM/YYYY',
        dateFormat: hideDays ? 'MM/yyyy' : 'dd/MM/yyyy',
        showMonthDropdown: true,
        useShortMonthInDropdown: true,
        showYearDropdown: true,
        yearDropdownItemNumber: 6,
        disabled: isDisabled,
        dropdownMode: "scroll",
        onChange: handleOnChange,
        onCalendarClose: handleOnCalendarClose,
        showMonthYearPicker: hideDays,
        popperPlacement: domDirection === ContentDirection.LTR ? 'bottom-start' : 'bottom-end',
        ref: datePickerRef
      }, {
        children: jsx("div", Object.assign({
          className: "react-datepicker__close-button-wrapper"
        }, {
          children: jsx("button", {
            className: "react-datepicker__close-button",
            type: "button",
            "aria-label": "close",
            onClick: function onClick() {
              var _a;
              if (datePickerRef.current !== null) {
                (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
              }
            }
          })
        }))
      }))
    })), jsx(ErrorMessage, {
      message: errorMessage
    })]
  }));
});
export { DateField };